import React from 'react';
import { Row, Col } from 'reactstrap';
import Toggle from '../../Toggle';
import ContentBox from './ContentBox';
import AvgRetailBox from './AvgRetailBox';

const Affordability = () => (
  <Row className="px-5 py-3 fade-in">
    <Col className="col-6">
      <Toggle label="Average Retail Price Display:" id="avgRetail" />
      <AvgRetailBox />

      <ContentBox contentBoxNumber="1" />
    </Col>
    <Col>
      <ContentBox contentBoxNumber="2" />
    </Col>
  </Row>
);

export default Affordability;
